import isWebos from '@accedo/xdk-device-lg-webos/esm/detection'
import isVizio from '@accedo/xdk-device-vizio-smartcast-contrib/esm/detection'
import { Router } from '@lightningjs/sdk'

import Button from '../../components/button/button'
import { HOME, LG_SIGN_UP, LOGIN, SIGN_UP, VIZIO_SIGN_UP } from '../../constants/routes'
import { getText } from '../../utils/dictionary'
import {
  captureClick,
  captureScreenData,
  NON_BFF_SEGMENT_SCREENS,
  SEGMENT_TRACK_EVENTS,
} from '../../utils/segmentAnalytics'
import BaseLanding from './baseLanding'

export default class Landing extends BaseLanding {
  static _template() {
    return {
      ...super._template(),
      LoginButton: {
        y: 860,
        x: 137,
        type: Button,
        label: getText('landingLoginButton'),
      },
      SignUpButton: {
        y: 860,
        x: 481,
        type: Button,
        label: getText('signUpButton'),
      },
    }
  }

  get loginButton() {
    return this.tag('LoginButton')
  }

  get signUpButton() {
    return this.tag('SignUpButton')
  }

  _active() {
    void captureScreenData(NON_BFF_SEGMENT_SCREENS.Landing)

    this._currentButton ??= this.loginButton
    this._refocus()
  }

  _handleEnter() {
    const eventName = (this._currentButton as Button).label.text.text
    const PAGE_CATEGORY = 'Landing'
    void captureClick(SEGMENT_TRACK_EVENTS.ButtonClicked, eventName, PAGE_CATEGORY, PAGE_CATEGORY)

    if (this._currentButton === this.loginButton) {
      Router.navigate(LOGIN, { goBack: Router.getHistory().length > 0, goSteps: -2 })
    } else if (this._currentButton === this.signUpButton) {
      if (isWebos) {
        Router.navigate(LG_SIGN_UP)
      } else if (isVizio && !window?.VIZIO?.Account?.isSVODEnabled()) {
        Router.navigate(VIZIO_SIGN_UP)
      } else {
        Router.navigate(SIGN_UP, { contextData: this._contextData })
      }
    } else {
      Router.navigate(HOME)
    }
  }

  _handleRight() {
    if (this._currentButton === this.loginButton) {
      this._currentButton = this.signUpButton
    }
  }

  _handleLeft() {
    if (this._currentButton === this.signUpButton) {
      this._currentButton = this.loginButton
    }
  }

  $updateFocusByHover(button) {
    this._currentButton = button
    this._refocus()
  }

  _onCursorLeave() {
    this._currentButton?._focus()
  }

  _handleClick() {
    this._handleEnter()
  }
}
